export default {
    GET_RESERVATION_REQUEST: 'RESERVATION_EDIT_PEOPLE_GET_RESERVATION_REQUEST',
    GET_RESERVATION_SUCCESS: 'RESERVATION_EDIT_PEOPLE_GET_RESERVATION_SUCCESS',
    SEARCH_PARTICIPANTS_REQUEST: 'RESERVATION_EDIT_PEOPLE_SEARCH_PARTICIPANTS_REQUEST',
    SEARCH_PARTICIPANTS_SUCCESS: 'RESERVATION_EDIT_PEOPLE_SEARCH_PARTICIPANTS_SUCCESS',
    UPDATE_PARTICIPANTS_REQUEST: 'RESERVATION_EDIT_PEOPLE_UPDATE_PARTICIPANTS_REQUEST',
    UPDATE_PARTICIPANTS_SUCCESS: 'RESERVATION_EDIT_PEOPLE_UPDATE_PARTICIPANTS_SUCCESS',
    DISPOSE: 'RESERVATION_EDIT_PEOPLE_DISPOSE_STORE',
};
